export default __webpack_public_path__ + "static/media/vintage-notebook.122e1108.png";